<mat-radio-group
  [ngModel]="selectedOption"
  (ngModelChange)="changeSelectedValue($event)"
>
  <mat-radio-button
    [value]="UserAgreementType.Primes"
    class="user-agreement-type-option"
    >{{
      'employee.user-agreement-sign.financing-plan-type-selection.options.primes-and-bonuses'
        | translate
    }}</mat-radio-button
  >
  <mat-radio-button
    [value]="UserAgreementType.SalarySacrifice"
    class="user-agreement-type-option"
    >{{
      'employee.user-agreement-sign.financing-plan-type-selection.options.salary-sacrifice'
        | translate
    }}</mat-radio-button
  >
  <mat-radio-button
    [value]="UserAgreementType.PrimesAndSalarySacrifice"
    class="user-agreement-type-option"
    >{{
      'employee.user-agreement-sign.financing-plan-type-selection.options.combined'
        | translate
    }}</mat-radio-button
  >
</mat-radio-group>
